type Props = {
  urlsp: string //onlicklink
  rurl: string //resource
  alts: string
  fw: number //fixed width
}

export const Blogo = ({ urlsp, rurl, alts, fw }: Props) => {
  const openInNewTab = (url: string) => {
    window.open(url, '_blank', 'noreferrer')
  }
  return (
    <div>
      <img
        onClick={() => openInNewTab(urlsp)}
        alt={alts}
        style={{
          width: fw + 'px',
        }}
        src={rurl}
      ></img>
    </div>
  )
}
